// import React, { useEffect, useRef, useState } from "react";
// import { motion, useAnimation, useInView } from "framer-motion";
// import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// const AboutUs = () => {
//   // State for animated counters
//   const [stats, setStats] = useState({
//     clients: 0,
//     retention: 0,
//     leads: 0,
//     years: 0,
//     campaigns: 0,
//     countries: 0,
//   });

//   const targetStats = {
//     clients: 250,
//     retention: 97,
//     leads: 75000,
//     years: 9,
//     campaigns: 1500,
//     countries: 35,
//   };

//   // Animation triggers
//   const statsRef = useRef(null);
//   const isInView = useInView(statsRef, { once: true });

//   // Animate counters
//   useEffect(() => {
//     if (isInView) {
//       const duration = 3; // seconds
//       const steps = 60; // frames per second

//       Object.keys(targetStats).forEach((key) => {
//         const target = targetStats[key];
//         const step = target / (duration * steps);
//         let current = 0;

//         const timer = setInterval(() => {
//           current += step;
//           if (current >= target) {
//             current = target;
//             clearInterval(timer);
//           }

//           setStats((prev) => ({
//             ...prev,
//             [key]:
//               key === "retention" ? current.toFixed(1) : Math.floor(current),
//           }));
//         }, 1000 / steps);
//       });
//     }
//   }, [isInView]);

//   // Core values data
//   const coreValues = [
//     {
//       title: "Client-Centric",
//       description:
//         "We put our clients at the heart of everything we do, delivering tailored solutions that drive real business impact.",
//       icon: "💎",
//     },
//     {
//       title: "Data-Driven",
//       description:
//         "Our decisions are rooted in data analytics and measurable results, ensuring maximum ROI for every campaign.",
//       icon: "📊",
//     },
//     {
//       title: "Innovative",
//       description:
//         "We constantly evolve our strategies to stay ahead of market trends and technological advancements.",
//       icon: "🚀",
//     },
//     {
//       title: "Transparent",
//       description:
//         "Honest communication and clear reporting are the foundation of our client relationships.",
//       icon: "🔍",
//     },
//   ];

//   // Client testimonials
//   const testimonials = [
//     {
//       quote:
//         "Augere Strategies  transformed our lead generation. Their targeted approach delivered 3x more qualified leads than our previous agency.",
//       author: "Sarah Johnson, CMO at TechNova",
//       role: "Marketing Director",
//     },
//     {
//       quote:
//         "The team's deep understanding of our industry and their data-driven approach has been instrumental in scaling our pipeline.",
//       author: "Michael Chen, VP Sales at CloudForge",
//       role: "Sales Executive",
//     },
//   ];

//   return (
//     <div className="overflow-hidden">
//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-br from-blue-50 to-blue-100 py-28 px-4 sm:px-6 lg:px-8 text-center">
//         <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10"></div>
//         <div className="relative max-w-7xl mx-auto">
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//             className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 font-serif tracking-tight"
//           >
//             About Augere Strategies
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.2 }}
//             className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-10 font-sans"
//           >
//             Pioneering demand generation solutions that bridge the gap between
//             innovative technology companies and their ideal customers.
//           </motion.p>
//         </div>
//       </section>

//       {/* Company Overview */}
//       <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8 }}
//               viewport={{ once: true }}
//             >
//               <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 font-serif">
//                 <span className="relative pb-2">
//                   Our Story
//                   <span className="absolute bottom-0 left-0 w-16 h-1 bg-orange-500 rounded-full"></span>
//                 </span>
//               </h2>
//               <div className="space-y-6 text-lg text-gray-600">
//                 <p>
//                   Founded in 2020 by a team of marketing technologists, Augere
//                   Strategies LLP began with a simple observation: technology
//                   companies were struggling to connect with their ideal
//                   customers amidst increasing market noise.
//                 </p>
//                 <p>
//                   What started as a boutique consultancy has grown into a
//                   full-service demand generation partner serving technology
//                   companies across three continents. Our unique blend of data
//                   science, marketing expertise, and sales alignment has helped
//                   hundreds of clients accelerate their growth.
//                 </p>
//                 <p>
//                   Today, we're recognized as one of the most innovative demand
//                   generation agencies in the tech sector, with awards and
//                   recognition from leading industry publications.
//                 </p>
//               </div>
//             </motion.div>
//             <motion.div
//               initial={{ opacity: 0, x: 50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8 }}
//               viewport={{ once: true }}
//               className="relative"
//             >
//               <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
//                 <img
//                   src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
//                   alt="Augere Strategies  team collaborating"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-2xl shadow-lg w-3/4">
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   Our Commitment
//                 </h3>
//                 <p className="text-gray-600">
//                   Delivering measurable pipeline growth through innovative,
//                   data-driven demand generation strategies.
//                 </p>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Core Values */}
//       <section className="py-24 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
//               Our Core Values
//             </h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
//               The principles that guide every decision we make and every
//               campaign we run
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {coreValues.map((value, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
//               >
//                 <div className="text-4xl mb-4">{value.icon}</div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">
//                   {value.title}
//                 </h3>
//                 <p className="text-gray-600">{value.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Methodology */}
//       <section className="py-24 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
//               Our Methodology
//             </h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
//               A proven framework for demand generation success
//             </p>
//           </div>

//           <div className="relative">
//             <div className="hidden lg:block absolute left-1/2 top-0 h-full w-1 bg-gradient-to-b from-blue-500 to-orange-500"></div>

//             {[
//               {
//                 title: "Discovery & Strategy",
//                 description:
//                   "We conduct in-depth analysis of your market, competitors, and buyer personas to develop a customized demand generation strategy.",
//                 icon: "🔎",
//               },
//               {
//                 title: "Audience Targeting",
//                 description:
//                   "Using our proprietary data models, we identify and segment your ideal customers with precision targeting.",
//                 icon: "🎯",
//               },
//               {
//                 title: "Content Development",
//                 description:
//                   "We create compelling, relevant content that resonates with your target audience at each stage of their journey.",
//                 icon: "✍️",
//               },
//               {
//                 title: "Multi-Channel Execution",
//                 description:
//                   "We deploy integrated campaigns across email, social, search, and display channels for maximum impact.",
//                 icon: "📡",
//               },
//               {
//                 title: "Lead Nurturing",
//                 description:
//                   "Our automated nurture streams keep prospects engaged until they're sales-ready.",
//                 icon: "🤝",
//               },
//               {
//                 title: "Measurement & Optimization",
//                 description:
//                   "Continuous performance tracking and data analysis ensure we're always improving results.",
//                 icon: "📈",
//               },
//             ].map((step, index) => (
//               <div
//                 key={index}
//                 className={`relative mb-12 lg:mb-16 ${
//                   index % 2 === 0
//                     ? "lg:text-right lg:pr-24"
//                     : "lg:text-left lg:pl-24"
//                 }`}
//               >
//                 <motion.div
//                   initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
//                   whileInView={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.6, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                   className={`bg-white p-8 rounded-xl shadow-md relative ${
//                     index % 2 === 0 ? "lg:mr-8" : "lg:ml-8"
//                   }`}
//                 >
//                   <div className="absolute -top-4 -left-4 lg:left-auto lg:-right-4 bg-blue-600 text-white text-2xl w-12 h-12 rounded-full flex items-center justify-center">
//                     {step.icon}
//                   </div>
//                   <h3 className="text-xl font-bold text-gray-900 mb-3">
//                     {step.title}
//                   </h3>
//                   <p className="text-gray-600">{step.description}</p>
//                 </motion.div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="py-24 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
//               Client Success Stories
//             </h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
//               Don't just take our word for it - hear from our clients
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 gap-8">
//             {testimonials.map((testimonial, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.2 }}
//                 viewport={{ once: true }}
//                 className="bg-white p-8 rounded-xl shadow-md"
//               >
//                 <div className="text-blue-600 text-4xl mb-4">"</div>
//                 <p className="text-lg text-gray-600 italic mb-6">
//                   {testimonial.quote}
//                 </p>
//                 <div className="flex items-center">
//                   <div className="bg-gray-200 w-12 h-12 rounded-full mr-4"></div>
//                   <div>
//                     <h4 className="font-bold text-gray-900">
//                       {testimonial.author}
//                     </h4>
//                     <p className="text-gray-500">{testimonial.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section
//         ref={statsRef}
//         className="py-24 bg-gradient-to-r from-blue-600 to-blue-800 text-white"
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {[
//               { value: stats.clients, label: "Clients Served", suffix: "+" },
//               {
//                 value: stats.retention,
//                 label: "Client Retention Rate",
//                 suffix: "%",
//               },
//               {
//                 value: stats.leads.toLocaleString(),
//                 label: "Leads Generated",
//                 suffix: "+",
//               },
//               { value: stats.years, label: "Years of Experience", suffix: "+" },
//               {
//                 value: stats.campaigns,
//                 label: "Campaigns Executed",
//                 suffix: "+",
//               },
//               {
//                 value: stats.countries,
//                 label: "Countries Served",
//                 suffix: "+",
//               },
//             ].map((stat, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="text-center"
//               >
//                 <div className="text-4xl md:text-5xl font-bold mb-2 font-serif">
//                   {stat.value}
//                   {stat.suffix}
//                 </div>
//                 <div className="text-xl font-sans">{stat.label}</div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-24 bg-white">
//         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//             viewport={{ once: true }}
//             className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 font-serif"
//           >
//             Ready to Accelerate Your Demand Generation?
//           </motion.h2>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.2 }}
//             viewport={{ once: true }}
//             className="text-xl text-gray-600 mb-8 font-sans"
//           >
//             Schedule a consultation with our experts to discuss how we can help
//             you achieve your growth objectives.
//           </motion.p>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.4 }}
//             viewport={{ once: true }}
//             className="flex flex-col sm:flex-row justify-center gap-4"
//           >
//             <a
//               href="tel:+441416282052"
//               className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-300 hover:-translate-y-1 flex items-center justify-center gap-2 text-lg"
//             >
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                 />
//               </svg>
//               +44 1416 282 052
//             </a>
//             <a
//               href="#"
//               className="px-8 py-4 border-2 border-blue-600 text-blue-600 font-medium rounded-lg transition-all duration-300 hover:-translate-y-1 hover:bg-blue-600 hover:text-white text-lg"
//             >
//               Request a Demo
//             </a>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;

import React, { useEffect, useRef, useState } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import logo1 from "./images/logo.svg";
import logo2 from "./images/logo2.png";
import logo3 from "./images/logo3.png";
import logo4 from "./images/logo4.png";
import logo5 from "./images/logo5.png";
import logo6 from "./images/logo6.png";

const AboutUs = () => {
  // State for animated counters
  const [stats, setStats] = useState({
    clients: 0,
    retention: 0,
    leads: 0,
    years: 0,
    campaigns: 0,
    countries: 0,
  });

  const targetStats = {
    clients: 13,
    retention: 97,
    leads: 75000,
    years: 5,
    campaigns: 1500,
    countries: 5,
  };

  // Animation triggers
  const statsRef = useRef(null);
  const isInView = useInView(statsRef, { once: true });

  // Animate counters
  useEffect(() => {
    if (isInView) {
      const duration = 3; // seconds
      const steps = 60; // frames per second

      Object.keys(targetStats).forEach((key) => {
        const target = targetStats[key];
        const step = target / (duration * steps);
        let current = 0;

        const timer = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }

          setStats((prev) => ({
            ...prev,
            [key]:
              key === "retention" ? current.toFixed(1) : Math.floor(current),
          }));
        }, 1000 / steps);
      });
    }
  }, [isInView]);

  // Core values data
  const coreValues = [
    {
      title: "Client-Centric",
      description:
        "We put our clients at the heart of everything we do, delivering tailored solutions that drive real business impact.",
      icon: "💎",
    },
    {
      title: "Data-Driven",
      description:
        "Our decisions are rooted in data analytics and measurable results, ensuring maximum ROI for every campaign.",
      icon: "📊",
    },
    {
      title: "Innovative",
      description:
        "We constantly evolve our strategies to stay ahead of market trends and technological advancements.",
      icon: "🚀",
    },
    {
      title: "Transparent",
      description:
        "Honest communication and clear reporting are the foundation of our client relationships.",
      icon: "🔍",
    },
  ];

  // Client logos data
  const clientLogos = [
    {
      name: "Informa",
      logo: logo1,
      url: "#",
    },
    {
      name: "Kingpu",
      logo: logo2,
      url: "#",
    },
    {
      name: "Emerald",
      logo: logo3,
      url: "#",
    },
    {
      name: "Huntington Bank",
      logo: logo4,
      url: "#",
    },
    {
      name: "PenFed Credit Union",
      logo: logo5,
      url: "#",
    },
    {
      name: "Midland Mortgage",
      logo: logo6,
      url: "#",
    },
  ];

  return (
    <div className="overflow-hidden">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-blue-100 py-28 px-4 sm:px-6 lg:px-8 text-center">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10"></div>
        <div className="relative max-w-7xl mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 font-serif tracking-tight"
          >
            About Augere Strategies
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-10 font-sans"
          >
            Pioneering demand generation solutions that bridge the gap between
            innovative technology company and their ideal customers.
          </motion.p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 font-serif">
                <span className="relative pb-2">
                  Our Story
                  <span className="absolute bottom-0 left-0 w-16 h-1 bg-orange-500 rounded-full"></span>
                </span>
              </h2>
              <div className="space-y-6 text-lg text-gray-600">
                <p>
                  Founded in 2020 by a team of marketing technologists, Augere
                  Strategies LLP began with a simple observation: technology
                  companies were struggling to connect with their ideal
                  customers amidst increasing market noise.
                </p>
                <p>
                  What started as a boutique consultancy has grown into a
                  full-service demand generation partner serving technology
                  companies across three continents. Our unique blend of data
                  science, marketing expertise, and sales alignment has helped
                  hundreds of clients accelerate their growth.
                </p>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                  alt="Augere Strategies  team collaborating"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-2xl shadow-lg w-3/4">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Our Commitment
                </h3>
                <p className="text-gray-600">
                  Delivering measurable pipeline growth through innovative,
                  data-driven demand generation strategies.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
              The principles that guide every decision we make and every
              campaign we run
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {coreValues.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="text-4xl mb-4">{value.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Methodology */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
              Our Methodology
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
              A proven framework for demand generation success
            </p>
          </div>

          <div className="relative">
            <div className="hidden lg:block absolute left-1/2 top-0 h-full w-1 bg-gradient-to-b from-blue-500 to-orange-500"></div>

            {[
              {
                title: "Discovery & Strategy",
                description:
                  "We conduct in-depth analysis of your market, competitors, and buyer personas to develop a customized demand generation strategy.",
                icon: "🔎",
              },
              {
                title: "Audience Targeting",
                description:
                  "Using our proprietary data models, we identify and segment your ideal customers with precision targeting.",
                icon: "🎯",
              },
              {
                title: "Content Development",
                description:
                  "We create compelling, relevant content that resonates with your target audience at each stage of their journey.",
                icon: "✍️",
              },
              {
                title: "Multi-Channel Execution",
                description:
                  "We deploy integrated campaigns across email, social, search, and display channels for maximum impact.",
                icon: "📡",
              },
              {
                title: "Lead Nurturing",
                description:
                  "Our automated nurture streams keep prospects engaged until they're sales-ready.",
                icon: "🤝",
              },
              {
                title: "Measurement & Optimization",
                description:
                  "Continuous performance tracking and data analysis ensure we're always improving results.",
                icon: "📈",
              },
            ].map((step, index) => (
              <div
                key={index}
                className={`relative mb-12 lg:mb-16 ${
                  index % 2 === 0
                    ? "lg:text-right lg:pr-24"
                    : "lg:text-left lg:pl-24"
                }`}
              >
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className={`bg-white p-8 rounded-xl shadow-md relative ${
                    index % 2 === 0 ? "lg:mr-8" : "lg:ml-8"
                  }`}
                >
                  <div className="absolute -top-4 -left-4 lg:left-auto lg:-right-4 bg-blue-600 text-white text-2xl w-12 h-12 rounded-full flex items-center justify-center">
                    {step.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">{step.description}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Logos Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
              Our Clients
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
              Trusted by leading companies across industries
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center"
          >
            {clientLogos.map((client, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
                className="flex justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-12 object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section
        ref={statsRef}
        className="py-24 bg-gradient-to-r from-blue-600 to-blue-800 text-white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { value: stats.clients, label: "Clients Served", suffix: "+" },
              // {
              //   value: stats.retention,
              //   label: "Client Retention Rate",
              //   suffix: "%",
              // },
              // {
              //   value: stats.leads.toLocaleString(),
              //   label: "Leads Generated",
              //   suffix: "+",
              // },
              { value: stats.years, label: "Years of Experience", suffix: "+" },
              // {
              //   value: stats.campaigns,
              //   label: "Campaigns Executed",
              //   suffix: "+",
              // },
              {
                value: stats.countries,
                label: "Countries Served",
                suffix: "+",
              },
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="text-4xl md:text-5xl font-bold mb-2 font-serif">
                  {stat.value}
                  {stat.suffix}
                </div>
                <div className="text-xl font-sans">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 font-serif"
          >
            Ready to Accelerate Your Demand Generation?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl text-gray-600 mb-8 font-sans"
          >
            Schedule a consultation with our experts to discuss how we can help
            you achieve your growth objectives.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row justify-center gap-4"
          >
            {/* <a
              href="tel:+441416282052"
              className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-300 hover:-translate-y-1 flex items-center justify-center gap-2 text-lg"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              +44 1416 282 052
            </a> */}
            <a
              href="/contact"
              className="px-8 py-4 border-2 border-blue-600 text-blue-600 font-medium rounded-lg transition-all duration-300 hover:-translate-y-1 hover:bg-blue-600 hover:text-white text-lg"
            >
              Request a Demo
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
